import React from 'react';
import PropTypes from 'prop-types';
import SynonymsComponent from '@Components/Results/targets/synonyms.component.jsx';

export default class ParameterCell extends React.PureComponent {

  render() {
    const { data, measurements } = this.props;

    return (
      <React.Fragment>
        {data}
        {measurements.length > 1 && (
          <SynonymsComponent
            list={measurements.split(' ')}
            prefix={''}
            separator={' '}
            coefficient={0.4}
            showCount={false}
          />
        )}
      </React.Fragment>
    );
  }
}

ParameterCell.propTypes = {
  data: PropTypes.string.isRequired,
  measurements: PropTypes.string.isRequired,
};
